import React from "react";
import { useSelector } from "react-redux";

import Lists from "./lists";
import PosOrder from "./form";

// --------API-------//

const PosSection = () => {
  const posHeader = useSelector((state) => state.posSlice);

  return <>{posHeader.isRestaurant ? <Lists /> : <PosOrder />}</>;
};

export default PosSection;
